module.exports = __webpack_public_path__ + "img/c_5.637c166f.jpg";